// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2YPEn","additionalInfo":"AgreementModal_additionalInfo__2kXZj"};